module.exports = __webpack_public_path__ + "static/media/ps.d7828021.jpg";